(() => {
  if (window.sealiooBundlesReady) return;
  window.sealiooBundlesReady = true;
  const selections = new Map();
  const variant = picker => {
    try { return JSON.parse(picker?.querySelector('script[type="application/json"]')?.textContent || 'null'); } catch (_) { return null; }
  };
  const apply = (box, picker, section) => {
    const state = selections.get(section.id);
    const current = variant(picker);
    if (!state || !current) return;
    if (state.waiting && String(current.id) !== state.waiting) return;
    state.waiting = null;
    const rows = [...box.querySelectorAll('[data-bundle-id]')];
    const selected = rows.find(row => row.dataset.bundleId === String(current.id));
    const target = rows.find(row => row.dataset.bundleColorValue === state.color && row.dataset.bundlePack === state.pack && !row.disabled);
    if (!selected || !target || selected === target) { selections.delete(section.id); return; }
    const changeColor = selected.dataset.bundleColorValue !== state.color;
    const optionName = changeColor ? 'Färg' : 'Paket';
    const optionValue = changeColor ? state.color : state.pack;
    const expected = rows.find(row => row.dataset.bundleColorValue === (changeColor ? state.color : selected.dataset.bundleColorValue) && row.dataset.bundlePack === (changeColor ? selected.dataset.bundlePack : state.pack));
    const input = [...picker.querySelectorAll('input[data-option-name]')].find(option => option.dataset.optionName === optionName && option.value === optionValue);
    if (!input || !expected) { selections.delete(section.id); return; }
    state.waiting = expected.dataset.bundleId;
    input.click();
  };
  const connectQuantities = () => {
    const money = cents => new Intl.NumberFormat('sv-SE',{style:'currency',currency:'SEK'}).format(cents/100);
    for (const box of document.querySelectorAll('.sealioo-quantity-packs')) {
      const section = box.closest('.shopify-section');
      const picker = section?.querySelector('variant-picker');
      const input = section?.querySelector('product-form-component input[name="quantity"]');
      if (!input) continue;
      const selected = variant(picker);
      const price = selected?.price ?? Number(box.dataset.selectedPrice);
      const quantity = Number(input.value) || 1;
      box.dataset.enhanced = 'true';
      for (const button of box.querySelectorAll('[data-pack-quantity]')) {
        const count = Number(button.dataset.packQuantity);
        button.setAttribute('aria-pressed',String(count===quantity));
        button.disabled = input.disabled || Boolean(input.max && count>Number(input.max));
        const deadline = box.dataset.packageDeadline;
        const active = !deadline || Date.now() <= Date.parse(deadline);
        const discount = active ? Math.max(0,Number(button.dataset.packDiscount)||0) : 0;
        const reference = price*count;
        const text = money(Math.max(0,reference-discount));
        const showSaving = box.dataset.showSavings==='true' && discount>0;
        const saving = button.querySelector('[data-pack-saving]');
        const comparison = button.querySelector('[data-pack-reference]');
        if(saving) {
          saving.hidden = !showSaving;
          const label = (box.dataset.saveLabel || 'Spara')+' '+money(discount)+' ('+Math.round(discount/reference*100)+' %)';
          if(saving.textContent!==label)saving.textContent=label;
        }
        if(comparison) {
          comparison.hidden = !showSaving;
          const value=comparison.querySelector('s');
          if(value && value.textContent!==money(reference))value.textContent=money(reference);
        }
        const total = button.querySelector('[data-pack-total]');
        if (total.textContent !== text) total.textContent = text;
      }
    }
  };
  const connect = () => {
    connectQuantities();
    for (const box of document.querySelectorAll('.sealioo-bundle-picker:not(.sealioo-quantity-packs)')) {
      const section = box.closest('.shopify-section');
      const picker = section?.querySelector('variant-picker');
      const selected = variant(picker);
      const row = box.querySelector(`[data-bundle-id="${selected?.id}"]`);
      if (!row) continue;
      const color = row.dataset.bundleColorValue;
      box.dataset.enhanced = 'true';
      picker.hidden = true;
      const colorText = box.querySelector('[data-current-color]');
      const colorLabel = [...box.querySelectorAll('[data-bundle-color]')].find(button => button.dataset.bundleColor === color)?.textContent.trim() || color;
      if (colorText.textContent !== colorLabel) colorText.textContent = colorLabel;
      for (const button of box.querySelectorAll('[data-bundle-color]')) button.setAttribute('aria-pressed',String(button.dataset.bundleColor===color));
      for (const button of box.querySelectorAll('[data-bundle-id]')) {
        button.hidden = button.dataset.bundleColorValue !== color;
        button.setAttribute('aria-pressed',String(button.dataset.bundleId===String(selected.id)));
      }
      apply(box, picker, section);
    }
  };
  document.addEventListener('click',event => {
    const button = event.target.closest('.sealioo-bundle-picker button');
    if (!button) return;
    const box = button.closest('.sealioo-bundle-picker');
    const section = box.closest('.shopify-section');
    if (button.dataset.packQuantity) {
      const input = section?.querySelector('product-form-component input[name="quantity"]');
      if (!input || input.disabled) return;
      input.value = button.dataset.packQuantity;
      input.dispatchEvent(new Event('blur',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
      connectQuantities();
      return;
    }
    const picker = section?.querySelector('variant-picker');
    const selected = variant(picker);
    const current = box.querySelector(`[data-bundle-id="${selected?.id}"]`);
    if (!current) return;
    const state = selections.get(section.id) || {color:current.dataset.bundleColorValue,pack:current.dataset.bundlePack,waiting:null};
    if (button.dataset.bundleId) state.pack = button.dataset.bundlePack;
    else state.color = button.dataset.bundleColor;
    selections.set(section.id,state);
    apply(box,picker,section);
  });
  document.addEventListener('change',event => {if(event.target.matches('input[name="quantity"]'))connectQuantities();});
  const start = () => { connect();const main=document.getElementById('MainContent');if(main)new MutationObserver(connect).observe(main,{childList:true,subtree:true}); };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',connect);
})();

